import React, { useState } from "react";
import { Link } from "react-router-dom";
import Css from "./Menu.module.css";
import { CiMenuBurger } from "react-icons/ci";
import { FaFacebookF, FaGithub, FaLinkedin } from "react-icons/fa";
const Menu = () => {
  const [setMenu, getMenu] = useState(false);
  return (
    <div>
      <header className={Css.parent}>
        <nav className={Css.container}>
          <div className={Css.menu}>
            <h1>MENU</h1>
            <button onClick={() => getMenu(!setMenu)}>
              <CiMenuBurger />
            </button>
          </div>
        </nav>
        <div className={`${Css.navbar} ${setMenu ? Css.back : ""}`}>
          <div className={Css.descraption}>
            <h1>Portfolio</h1>
            <button onClick={() => getMenu(false)}>X</button>
          </div>
          <ul>
            <li>
              <Link to="" onClick={() => window.scrollTo(0, 0)}>
                Home
              </Link>
            </li>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#about">Skills</a>
            </li>
            <li>
              <a href="#works">My Work</a>
            </li>
            <li>
              <a href="#certificate">Certificate</a>
            </li>
          </ul>
          <div className={Css.info}>
            <p>
              Welcome To My Portfolio, I Did This Website To See All My
              Projects, I Wish This Portfolio Like You
            </p>
            <div className={Css.icons}>
              <Link to="https://www.facebook.com/profile.php?id=100012706116123">
                <FaFacebookF />
              </Link>
              <Link to="https://www.linkedin.com/in/mohamed-adel-226611286/">
                <FaLinkedin />
              </Link>
              <Link to="https://github.com/Mohamed-Adel0">
                <FaGithub />
              </Link>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Menu;
